import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, OnInit, HostListener, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { QuillEditorComponent, QuillModule } from 'ngx-quill';

@Component({
    selector: 'input-editor',
    template: `
<quill-editor
  #quillEditor
  id="editor"
  [format]="'html'"
  [sanitize]="true"
  [ngClass]="{ unfocused: !focused, focused: focused, joiStyling: joiStyling, disabled: disabled }"
  [(ngModel)]="savedData" 
  [placeholder]="placeholder"
  [disabled]="disabled"
  (clickOutside)="save()"
  (clickInside)="disabled ? null : focused = true"
  (onFocus)="focus($event)" 
  (onBlur)="save()"
></quill-editor>
<!-- <div [ngClass]="{ hidden: focused || disabled }" class="action-button-placeholder"></div> -->
`,
    styleUrls: ['./input-editor.scss'],
    standalone: true,
    imports: [CommonModule, QuillModule, FormsModule]
})
export class InputEditorComponent<T, P extends keyof T> implements OnInit, OnChanges, OnDestroy {
  @Input() object: T
  @Input() prop: P
  @Input() placeholder = ''
  @Input() showAlign: boolean
  @Input() disabled: string | boolean
  @Output() changed: EventEmitter<T[P]> = new EventEmitter();
  @Input() joiStyling = false
  @Input() forceSave: Subject<void>
  savedData
  @ViewChild(QuillEditorComponent) quillEditor: QuillEditorComponent
  focused
  blurred = true;
  listener
  
  constructor() {
    this.listener = () => {
      if (!this.focused) return
      console.log("BLUR CALLED FROM INPUT EDITOR WITH VALUE: " + this.savedData)
      this.save()
    }
    window.addEventListener('blur', this.listener) // can't add to store since this is a public component, grr
  }

  ngOnDestroy(): void {
    this.listener();
    window.removeEventListener('blur', this.listener)
    if (this.forceSave) {
      this.forceSave.next();
      this.forceSave.complete();
    }
  }

  ngOnInit() {
    this.savedData = this.object[this.prop]
    if (this.forceSave) {
      this.forceSave.subscribe(() => {
        this.save()
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.focused) return // ignore changes when focused
    this.savedData = this.object[this.prop] // otherwise update
  }

  focus($event: any) {
    // tslint:disable-next-line:no-console
    console.log('focus', $event)
    if(this.disabled) return
    this.focused = true
    this.blurred = false
  }

  save() {
    if(!this.focused || this.savedData === this.object[this.prop]) return
    this.focused = false
    this.object[this.prop] = this.savedData
    this.changed.emit(this.savedData)
  }

}

